import { cn } from "@/lib/utils";

export const SectionHero = ({
  className,
  innerClassName,
  children,
}: {
  className?: string;
  innerClassName?: string;
  children: React.ReactNode;
}) => {
  return (
    <section
      className={cn(
        "relative before:absolute before:top-0 before:left-0 before:block before:w-full before:rounded-b-none md:before:h-32 md:before:rounded-b-xl lg:before:bg-primary",
        className
      )}
    >
      <div
        className={cn(
          "md:-mx-6 relative mx-auto rounded-t-xl bg-white p-4 md:p-6",
          innerClassName
        )}
      >
        {children}
      </div>
    </section>
  );
};
